import { UpdateCourseType } from "../../../types/Course";
import { put } from "../../../utils/axios-config";
import { COURSES } from "../../../utils/constants";

export const updateCourse = async (data:UpdateCourseType) => {
    return await put<UpdateCourseType, string>(COURSES, data);
};